import React, { useState } from "react";
import styled from "styled-components";

const AvatarContainer = styled.div`
  width: ${(props) => props.size || "40px"};
  height: ${(props) => props.size || "40px"};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.background || "var(--color-accent)"};
  color: white;
  font-weight: 600;
  font-size: ${(props) => props.fontSize || "14px"};
  text-transform: uppercase;
  flex-shrink: 0;
  border: ${(props) => props.border || "none"};
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: ${(props) => (props.show ? "block" : "none")};
`;

const Avatar = ({
  src,
  alt,
  size = "40px",
  fontSize = "14px",
  background = "var(--color-accent)",
  border = "none",
  ...props
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Generate initials from display name or email
  const getInitials = (name) => {
    if (!name) return "?";

    // If it's an email, use the part before @
    if (name.includes("@")) {
      name = name.split("@")[0];
    }

    // Split by spaces and get first letter of each word
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }

    return name[0]?.toUpperCase() || "?";
  };

  const initials = getInitials(alt);
  const shouldShowImage = src && !imageError && imageLoaded;

  return (
    <AvatarContainer
      size={size}
      fontSize={fontSize}
      background={background}
      border={border}
      {...props}
    >
      {shouldShowImage ? (
        <AvatarImage
          src={src}
          alt={alt}
          show={true}
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            setImageError(true);
            setImageLoaded(false);
          }}
        />
      ) : (
        initials
      )}
    </AvatarContainer>
  );
};

export default Avatar;
